// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__C65F4","actionsCol":"EnrolledClinics_actionsCol__2ysw-"};